export const sanitizeHref = (url?: string): string | undefined => {
  if (!url) return undefined;
  try {
    const { protocol } = new URL(url);
    if (protocol === "http:" || protocol === "https:") return url;
  } catch {
    // invalid URL
  }
  return undefined;
};
